<div class="employee-settings page-shell">
  <mat-toolbar class="header">
    <span>{{ "settings.employeeFields" | translate }}</span>
    <div class="header-buttons">
      <button
        mat-flat-button
        color="primary"
        type="button"
        class="add-button"
        (click)="addNewEmployeeSetting()"
        [disabled]="isLoading"
      >
        <mat-icon>add</mat-icon>
        {{ "settings.new" | translate }}
      </button>
      <button
        mat-raised-button
        color="primary"
        type="button"
        (click)="onSubmit()"
        [disabled]="saving || !hasChanges || isLoading"
      >
        <mat-spinner *ngIf="saving" diameter="20" class="dc-btn-spinner"></mat-spinner>
        <mat-icon *ngIf="!saving" class="btn-icon">save</mat-icon>
        <span>{{ saving ? ("saving" | translate) : ("save" | translate) }}</span>
      </button>
    </div>
  </mat-toolbar>

  <div class="employee-settings-content">
  <div class="form" [formGroup]="form">
    <div
      class="table-container"
      [class.table-container--empty]="!isLoading && dataSource.data.length === 0"
      [class.table-container--loading]="isLoading"
    >
      <table
        mat-table
        [dataSource]="dataSource"
        class="settings-table mat-elevation-z0"
      >
        <ng-container matColumnDef="customField">
          <th mat-header-cell *matHeaderCellDef>
            {{ "settings.customField" | translate }}
          </th>
          <td mat-cell *matCellDef="let employeeSetting">
            {{ employeeSetting.value.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="customLabel">
          <th mat-header-cell *matHeaderCellDef>
            {{ "settings.customLabel" | translate }}
          </th>
          <td mat-cell *matCellDef="let employeeSetting">
            <mat-form-field appearance="outline">
              <input
                matInput
                [formControl]="employeeSetting.get('label')"
                type="text"
                [errorStateMatcher]="errorStateMatcher"
              />
              <mat-error
                *ngIf="employeeSetting.get('label')?.hasError('required')"
              >
                {{ "fieldRequired" | translate }}
              </mat-error>
            </mat-form-field>
          </td>
        </ng-container>

                <ng-container matColumnDef="icon">
          <th mat-header-cell *matHeaderCellDef>
            <span class="header-cell-inner">
              {{ "settings.variableIcon" | translate }}
              <mat-icon
                class="header-help"
                [matTooltip]="'settings.variableIconHint' | translate"
                matTooltipPosition="above"
                [attr.aria-label]="'settings.variableIconHint' | translate"
                >help_outline</mat-icon
              >
            </span>
          </th>
          <td mat-cell *matCellDef="let employeeSetting">
            <mat-form-field appearance="outline" class="variable-icon-field icon-select-field">
              <mat-select
                [formControl]="employeeSetting.get('iconUrl')"
                [disabled]="mediaImagesLoading"
              >
                <mat-select-trigger>
                  <span class="variable-icon-trigger">
                    @if (
                      mediaFilePreview(
                        employeeSetting.get("iconUrl")?.value
                      );
                      as preview
                    ) {
                      <span class="variable-icon-trigger__file" aria-hidden="true">
                        <mat-icon>{{ preview.icon }}</mat-icon>
                        <span>{{ preview.label }}</span>
                      </span>
                    } @else {
                      <img
                        [src]="iconSrc(employeeSetting.get('iconUrl')?.value)"
                        alt=""
                        class="variable-icon-trigger__img"
                        width="22"
                        height="22"
                        loading="lazy"
                      />
                    }
                    {{ iconLabel(employeeSetting.get("iconUrl")?.value) }}
                  </span>
                </mat-select-trigger>
                <mat-option
                  *ngIf="isUnknownIconUrl(employeeSetting.get('iconUrl')?.value)"
                  [value]="employeeSetting.get('iconUrl')?.value"
                >
                  <span class="variable-icon-option">
                    @if (
                      mediaFilePreview(
                        employeeSetting.get("iconUrl")?.value
                      );
                      as preview
                    ) {
                      <span class="variable-icon-option__file" aria-hidden="true">
                        <mat-icon>{{ preview.icon }}</mat-icon>
                        <span>{{ preview.label }}</span>
                      </span>
                    } @else {
                      <img
                        [src]="iconSrc(employeeSetting.get('iconUrl')?.value)"
                        alt=""
                        class="variable-icon-option__img"
                        width="28"
                        height="28"
                      />
                    }
                    <span>{{
                      iconLabel(employeeSetting.get("iconUrl")?.value)
                    }}</span>
                  </span>
                </mat-option>
                <mat-option
                  *ngFor="let icon of hardcodedIcons"
                  [value]="icon.value"
                >
                  <span class="variable-icon-option">
                    <img
                      [src]="icon.preview"
                      alt=""
                      class="variable-icon-option__img"
                      width="28"
                      height="28"
                    />
                    <span>{{ icon.label }}</span>
                  </span>
                </mat-option>
                <mat-option
                  *ngFor="let image of mediaImages"
                  [value]="image.imageUrl"
                >
                  <span class="variable-icon-option">
                    @if (mediaFilePreview(image.imageUrl); as preview) {
                      <span class="variable-icon-option__file" aria-hidden="true">
                        <mat-icon>{{ preview.icon }}</mat-icon>
                        <span>{{ preview.label }}</span>
                      </span>
                    } @else {
                      <img
                        [src]="image.imageUrl"
                        alt=""
                        class="variable-icon-option__img"
                        width="28"
                        height="28"
                      />
                    }
                    <span>{{ image.name }}</span>
                  </span>
                </mat-option>
              </mat-select>
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="mandatory">
          <th mat-header-cell *matHeaderCellDef>
            <span class="header-cell-inner">
              {{ "settings.mandatory" | translate }}
              <mat-icon
                class="header-help"
                [matTooltip]="'settings.mandatoryHint' | translate"
                matTooltipPosition="above"
                [attr.aria-label]="'settings.mandatoryHint' | translate"
                >help_outline</mat-icon
              >
            </span>
          </th>
          <td mat-cell *matCellDef="let employeeSetting">
            <mat-checkbox
              [formControl]="employeeSetting.get('mandatory')"
              color="primary"
            ></mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="overridable">
          <th mat-header-cell *matHeaderCellDef>
            <span class="header-cell-inner">
              {{ "settings.overridable" | translate }}
              <mat-icon
                class="header-help"
                [matTooltip]="'settings.overridableHint' | translate"
                matTooltipPosition="above"
                [attr.aria-label]="'settings.overridableHint' | translate"
                >help_outline</mat-icon
              >
            </span>
          </th>
          <td mat-cell *matCellDef="let employeeSetting">
            <mat-checkbox
              [formControl]="employeeSetting.get('overridable')"
              color="primary"
            ></mat-checkbox>
          </td>
        </ng-container>

        <ng-container matColumnDef="defaultValue">
          <th mat-header-cell *matHeaderCellDef>
            <span class="header-cell-inner">
              {{ "settings.defaultValue" | translate }}
              <mat-icon
                class="header-help"
                [matTooltip]="'settings.defaultValueHint' | translate"
                matTooltipPosition="above"
                [attr.aria-label]="'settings.defaultValueHint' | translate"
                >help_outline</mat-icon
              >
            </span>
          </th>
          <td mat-cell *matCellDef="let employeeSetting">
            <mat-form-field appearance="outline">
              <input
                matInput
                [formControl]="employeeSetting.get('defaultValue')"
                type="text"
              />
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>
            {{ "settings.actionsColumn" | translate }}
          </th>
          <td mat-cell *matCellDef="let employeeSetting; let rowIndex = index">
            <div class="table-actions">
              <button
                *ngIf="canRemoveSetting(employeeSetting)"
                type="button"
                class="action-btn action-btn--danger"
                [matTooltip]="'settings.removeRow' | translate"
                [attr.aria-label]="'settings.removeRow' | translate"
                (click)="confirmRemoveEmployeeSetting(rowIndex)"
              >
                <mat-icon>delete_outline</mat-icon>
                {{ "delete" | translate }}
              </button>
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayedColumns"
          [formGroup]="row"
        ></tr>
      </table>

      <div class="loading-wrapper" *ngIf="isLoading">
        <app-loading></app-loading>
      </div>

      <div class="empty-state" *ngIf="!isLoading && dataSource.data.length === 0">
        <mat-icon class="empty-state__icon">tune</mat-icon>
        <p>{{ "settings.noEmployeeSettings" | translate }}</p>
      </div>
    </div>
  </div>
  </div>
</div>
